import styled from 'styled-components';

export const Container = styled.div`

  width: 100%;
  position: fixed;
  bottom: 0;
  background-color: #FFF;
  padding: 8;
  justify-content: center;
  align-items: center;
  display: flex;
  text-align: center;
  flex-direction: column;
  flex: 1;
  min-height: 70px;

  .text-small{
    font-size: 12px!important;
  }

  .footer-logo{
    height: 70px;
    position: fixed;
    z-index: 999999;
    bottom: 0;
    background-color: #FFF;
    padding: 8;
    justify-content: center;
    display: flex;
    flex-direction: column;
    left: 0;
    margin-left: 10px;
    
    

    @media only screen and (max-width: 600px) {
      position: relative;
    }
  }
  `;

export const Logo = styled.img`
  height: 70px;
  object-fit: contain;

`;
